import type { ToolMark } from './schema'

const mark = (name: string, file: string, mono?: true): ToolMark => ({ name, logo: `/images/tools/${file}`, mono })

/**
 * Every tool logo the site can show. Pages reference these, never a raw path. The HighLevel feature
 * marks are the v1 tool strip's glyphs with their brand colours baked in.
 */
export const tools = {
  gohighlevel: mark('GoHighLevel', 'gohighlevel.png'),
  workflows: mark('Workflows', 'ghl-workflows.svg'),
  pipelines: mark('CRM & Pipelines', 'ghl-pipeline.svg'),
  funnels: mark('Funnels & Websites', 'ghl-funnel.svg'),
  voiceAi: mark('Voice AI', 'ghl-voice.svg'),
  aiAutomation: mark('AI Automation', 'ghl-ai.svg'),
  emailSms: mark('Email & SMS', 'ghl-mail.svg'),
  calendars: mark('Calendars & Booking', 'ghl-calendar.svg'),
  whatsapp: mark('WhatsApp routing', 'ghl-chat.svg'),
  googleWorkspace: mark('Google Workspace', 'google-workspace.svg'),
} satisfies Record<string, ToolMark>

/** The daily drivers, in the order v1's tool strip showed them. */
export const dailyTools: ToolMark[] = [
  tools.gohighlevel,
  tools.workflows,
  tools.pipelines,
  tools.funnels,
  tools.voiceAi,
  tools.aiAutomation,
  tools.emailSms,
  tools.calendars,
  tools.whatsapp,
  tools.googleWorkspace,
]
